import { Link } from "react-router-dom";
import { EMAIL, PHONE, PHONE_TEL } from "@/lib/fda";
import { LEGAL_DISCLOSURE } from "@/lib/legal";

export const LegalDisclosure = () => (
  <section className="bg-sand-deep px-5 py-14 lg:px-10" data-testid="legal-disclosure">
    <div className="mx-auto max-w-4xl">
      <h2 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-forest-soft">Important information</h2>
      <p className="text-sm leading-relaxed text-forest-soft">{LEGAL_DISCLOSURE}</p>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="bg-forest px-5 pb-10 pt-16 text-sand lg:px-10" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-4">
      <div>
        <img src="/logo-on-dark.png" alt="Freedom Debt Advice" data-testid="footer-logo"
          className="h-20 w-auto max-w-full object-contain object-left" />
        <p className="mt-4 text-sm text-sand/70">A trading name of RJA Solutions Ltd</p>
        <p className="mt-1 text-sm text-sand/70">Company number 14390777</p>
      </div>
      <div>
        <p className="mb-3 text-xs font-bold uppercase tracking-widest text-sand/50">Pages</p>
        {[["/how-it-works", "How It Works"], ["/debt-options", "Debt Options"], ["/faqs", "FAQs"], ["/contact", "Contact"]].map(([to, l]) => (
          <Link key={to} to={to} className="block py-1 text-sm text-sand/80 hover:text-white">{l}</Link>
        ))}
      </div>
      <div>
        <p className="mb-3 text-xs font-bold uppercase tracking-widest text-sand/50">Legal</p>
        {[["/privacy-policy", "Privacy Policy"], ["/cookie-policy", "Cookie Policy"], ["/terms-and-conditions", "Terms & Conditions"]].map(([to, l]) => (
          <Link key={to} to={to} className="block py-1 text-sm text-sand/80 hover:text-white">{l}</Link>
        ))}
      </div>
      <div>
        <p className="mb-3 text-xs font-bold uppercase tracking-widest text-sand/50">Contact</p>
        <a href={`tel:${PHONE_TEL}`} className="block py-1 text-sm text-sand/80 hover:text-white" data-testid="footer-phone">{PHONE}</a>
        <a href={`mailto:${EMAIL}`} className="block py-1 text-sm text-sand/80 hover:text-white">{EMAIL}</a>
        <p className="mt-3 text-sm text-sand/60">20 Stephen Street, Urmston, Manchester, M41 9AT</p>
      </div>
    </div>
    <div className="mx-auto mt-12 max-w-7xl border-t border-sand/15 pt-6 text-xs text-sand/50">
      ICO Fee Payer Register Number: ZC126432 &middot; Governing law: England and Wales
    </div>
  </footer>
);
